/* Scheda nuova al telefono (impostazione bh_scheda_nuova della sezione main-product). Lavora solo dentro #MainContent .bh-sn-scheda.
   1. I segmenti in alto sulla foto, uno per lastra, che seguono lo scorrimento.
   2. La cassa corta ferma in basso al telefono: la riga col nome e il prezzo (copiati dal capo), che non si ripete quando il titolo sotto la foto
      è in vista; passata la galleria si accorcia a taglie e bottone col prezzo dentro. Il bottone resta vuoto finché manca la taglia. Il
      carrello lo fa il bottone vero del tema, questo script non fa richieste sue.
   3. Il visore: col visore aperto la cassa resta sopra, si compra senza uscire dalle foto.
   4. «Manda questa pagina», col foglio di condivisione del telefono o copiando il link.
   5. L'ordine sotto la foto: la stampa da vicino subito dopo le righe di servizio, le briciole in fondo alla pagina. Si spostano appena la
      pagina è letta, quando stanno ancora sotto lo schermo, quindi non si vede niente muoversi. */
(function () {
  var d = document, h = d.documentElement;
  var scheda = d.querySelector('#MainContent .bh-sn-scheda');
  if (!scheda) return;
  var lista = scheda.querySelector('.product__media-list');
  var galleria = scheda.querySelector('media-gallery');
  var cassa = scheda.querySelector('[data-bh-sn-cassa]');
  var tel = window.matchMedia('(max-width: 767px)');

  function testo(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function nuovo(tag, classe, t) { var e = d.createElement(tag); if (classe) e.className = classe; if (t) e.textContent = t; return e; }

  // solo nell'anteprima di un tema non pubblicato: Shopify mette in basso la sua barra (iframe PBarNextFrame), alta circa 64 px al telefono;
  // la cassa sale di tanto. Sul sito vero l'iframe non c'è e non cambia niente
  // quando la barra compare o sparisce si rifanno la riga del nome (titolo in vista o no) e il fondo della cassa
  function anteprima() {
    var c = !!(d.getElementById('PBarNextFrame') || d.getElementById('preview-bar-iframe'));
    var prima = !!h.style.getPropertyValue('--bh-sn-anteprima');
    if (c === prima) return;
    if (c) h.style.setProperty('--bh-sn-anteprima', '64px'); else h.style.removeProperty('--bh-sn-anteprima');
    if (window.bhSnRifai) window.bhSnRifai();
    if (window.bhSnGiu) window.bhSnGiu();
  }
  anteprima();
  if ('MutationObserver' in window) new MutationObserver(anteprima).observe(d.body || h, { childList: true, subtree: true });

  /* ---------- 1. lastra R1 e segmenti ---------- */
  function lastraR1() {
    var t = d.getElementById('bh-sn-r1');
    if (!t || !lista || lista.querySelector('.bh-sn-r1')) return;
    var li = nuovo('li', 'bh-sn-r1');
    var box = nuovo('div');
    box.appendChild(t.content.cloneNode(true));
    li.appendChild(box);
    lista.appendChild(li);
    var a = li.querySelector('a[href="#bh-sn-esteso"]');
    if (a) a.addEventListener('click', function (e) {
      var x = d.getElementById('bh-sn-esteso');
      if (!x) return;
      e.preventDefault();
      x.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }
  var segmenti = null;
  function lastre() {
    if (!lista) return [];
    var tutte = Array.prototype.filter.call(lista.children, function (x) { return (x.classList.contains('product__media-item') && !x.classList.contains('hidden')) || x.classList.contains('bh-sn-r1'); });
    return tutte.map(function (x, i) { return { el: x, o: parseInt(getComputedStyle(x).order, 10) || 0, i: i }; })
      .sort(function (a, b) { return a.o - b.o || a.i - b.i; }).map(function (x) { return x.el; });
  }
  function disegnaSegmenti() {
    if (!galleria || !lista) return;
    var n = lastre().length;
    if (!segmenti) { segmenti = nuovo('div', 'bh-sn-segmenti'); segmenti.setAttribute('aria-hidden', 'true'); galleria.appendChild(segmenti); }
    segmenti.innerHTML = '';
    if (n < 2) return;
    for (var i = 0; i < n; i++) segmenti.appendChild(nuovo('i'));
    seguiSegmenti();
  }
  function seguiSegmenti() {
    if (!segmenti || !lista) return;
    var w = lista.clientWidth || 1, k = Math.round(Math.abs(lista.scrollLeft) / w);
    Array.prototype.forEach.call(segmenti.children, function (s, i) { s.classList.toggle('is-qui', i === k); });
  }
  if (lista) {
    lista.addEventListener('scroll', function () { window.requestAnimationFrame(seguiSegmenti); }, { passive: true });
    new MutationObserver(function (m) {
      if (m.some(function (x) { return x.attributeName === 'class'; })) disegnaSegmenti();
    }).observe(lista, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  /* ---------- 2. la cassa ---------- */
  function varianteScelta() {
    var r = cassa ? cassa.querySelector('variant-radios') : null;
    if (!r) return null;
    var gruppi = r.querySelectorAll('fieldset'), valori = [];
    for (var i = 0; i < gruppi.length; i++) {
      var c = gruppi[i].querySelector('input[type=radio]:checked');
      if (!c) return null;
      valori.push(c.value);
    }
    var vv = [];
    try { vv = JSON.parse(r.querySelector('script[type="application/json"]').textContent); } catch (e) {}
    return vv.filter(function (v) { return v.options && v.options.length === valori.length && v.options.every(function (o, k) { return o === valori[k]; }); })[0] || null;
  }
  // nome e prezzo nella riga della cassa, e il prezzo dentro il bottone quando la cassa è corta: copiati dal capo sotto la foto, così sono
  // sempre quelli della taglia scelta (global.js riscrive il prezzo a ogni cambio)
  function aggiornaCassa() {
    if (!cassa) return;
    var capo = scheda.querySelector('.bh-sn-capo');
    var cifre = cassa.querySelector('[data-bh-sn-cifre]');
    var bo = capo && capo.querySelector('.badge__container .badge');
    var ora = capo && capo.querySelector('.product__price .new-price-style');
    var prima = capo && capo.querySelector('.product__price .compare-at-price-style');
    if (cifre) {
      var prova = nuovo('span');
      if (bo && testo(bo)) { var b = nuovo('span', 'badge'); var bd = nuovo('bdi', '', testo(bo)); bd.setAttribute('dir', 'ltr'); b.appendChild(bd); prova.appendChild(b); }
      if (ora && testo(ora)) prova.appendChild(nuovo('span', '', testo(ora)));
      if (prima && testo(prima)) prova.appendChild(nuovo('s', '', testo(prima)));
      // si riscrive solo se è cambiato: la cassa è osservata, e riscriverla sempre farebbe girare l'osservatore all'infinito
      if (cifre.innerHTML !== prova.innerHTML) cifre.innerHTML = prova.innerHTML;
    }
    giu();
    var tasse = cassa.querySelector('[data-bh-sn-tasse]'), tc = capo && capo.querySelector('.product__tax');
    if (tasse && tasse.textContent !== testo(tc)) tasse.textContent = testo(tc);
    var v = varianteScelta();
    var senza = !v && !!cassa.querySelector('[data-bh-taglie]');
    cassa.classList.toggle('is-senza-taglia', senza);
    var btn = cassa.querySelector('.product__buttons button[name="add"]');
    if (btn) {
      // senza taglia il bottone dice «Scegli la taglia» (chiave già tradotta); scelta la taglia torna «Aggiungi al carrello». Sulle taglie
      // esaurite e sui capi esauriti il bottone resta quello del tema («Esaurito», spento)
      var et = btn.querySelector('span'), scegli = cassa.getAttribute('data-scegli') || '', aggiungi = cassa.getAttribute('data-aggiungi') || '';
      if (et && scegli) {
        if (senza && !btn.disabled) { if (testo(et) !== scegli) et.textContent = scegli; }
        else if (testo(et) === scegli && aggiungi) et.textContent = aggiungi;
      }
      // il prezzo dentro il bottone (si vede con la cassa corta): quello della taglia scelta; senza taglia quello del capo com'è scritto sotto
      // la foto, quindi «Da €55,00» sui capi coi prezzi diversi per taglia, mai la cifra da sola
      var p = btn.querySelector('.bh-sn-prezzo-nel-bottone');
      var dentro = '';
      if (ora && testo(ora)) {
        if (v && v.available) dentro = '· ' + testo(ora).replace(/^\D*?(?=[\d€$£])/, '');
        else if (senza && !btn.disabled) dentro = '· ' + testo(ora);
      }
      if (!p && dentro) { p = nuovo('span', 'bh-sn-prezzo-nel-bottone'); if (et) et.after(p); else btn.appendChild(p); }
      if (p && p.textContent !== dentro) p.textContent = dentro;
    }
  }
  var osservaCassa = null;
  // quanto scende il fondo bianco della cassa: fino alle taglie se è corta, fino alla riga della scarsità se il nome non serve
  function giu() {
    if (!cassa || !tel.matches) { h.style.removeProperty('--bh-sn-giu'); return; }
    var top = cassa.getBoundingClientRect().top, a = null;
    // corta: la parte bianca parte 15 px sopra le taglie, così è 121 px come nella B (taglie, bottone e i loro margini)
    var sopra = 8;
    if (h.classList.contains('bh-sn-corta')) { a = cassa.querySelector('variant-radios'); sopra = 15; }
    else if (h.classList.contains('bh-sn-senza-testa')) a = cassa.querySelector('.bh-sn-riga2');
    h.style.setProperty('--bh-sn-giu', a ? Math.max(0, Math.round(a.getBoundingClientRect().top - top - sopra)) + 'px' : '0px');
  }
  window.bhSnGiu = giu;
  function corta(si) { h.classList.toggle('bh-sn-corta', !!si && tel.matches); giu(); }
  if (galleria && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (voci) {
      var e = voci[0];
      corta(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: [0] }).observe(galleria);
  }
  var titolo = scheda.querySelector('.bh-sn-capo h1');
  if (titolo && cassa && 'IntersectionObserver' in window) {
    // il titolo è «in vista» se sta tutto sopra la cassa
    var io = null;
    var rifai = function () {
      if (io) io.disconnect();
      // lo spazio sotto il titolo è quello che la cassa copre col nome dentro, più la barra dell'anteprima se c'è
      var alta = tel.matches ? cassa.getBoundingClientRect().height + (parseFloat(getComputedStyle(h).getPropertyValue('--bh-sn-anteprima')) || 0) : 0;
      io = new IntersectionObserver(function (voci) {
        h.classList.toggle('bh-sn-senza-testa', tel.matches && voci[0].intersectionRatio > 0.99);
        giu();
      }, { threshold: [0, 0.99, 1], rootMargin: '0px 0px -' + Math.round(alta) + 'px 0px' });
      io.observe(titolo);
    };
    rifai();
    window.bhSnRifai = rifai;
    if (tel.addEventListener) tel.addEventListener('change', rifai);
  }
  if (cassa) {
    cassa.addEventListener('change', function () { window.requestAnimationFrame(aggiornaCassa); });
    osservaCassa = new MutationObserver(function () { window.requestAnimationFrame(aggiornaCassa); });
    osservaCassa.observe(cassa, { childList: true, subtree: true });
    var capo = scheda.querySelector('.bh-sn-capo');
    if (capo) new MutationObserver(function () { window.requestAnimationFrame(aggiornaCassa); }).observe(capo, { childList: true, subtree: true });
  }

  /* ---------- 3. il visore ---------- */
  // la finestra delle foto del tema si sposta da sola in fondo al body: si cerca per id
  var modale = d.querySelector('product-modal[id^="ProductModal-"]');
  if (modale) new MutationObserver(function () { h.classList.toggle('bh-sn-visore', modale.hasAttribute('open')); }).observe(modale, { attributes: true, attributeFilter: ['open'] });

  /* ---------- 4. «Manda questa pagina» ---------- */
  var manda = scheda.querySelector('[data-bh-sn-manda]');
  if (manda) manda.addEventListener('click', function () {
    var esito = manda.parentNode.querySelector('.bh-sn-manda-esito');
    var url = location.href.split('#')[0];
    var detto = function () { if (esito) { esito.textContent = manda.getAttribute('data-copiato') || ''; setTimeout(function () { esito.textContent = ''; }, 2500); } };
    if (navigator.share) {
      navigator.share({ title: manda.getAttribute('data-titolo') || d.title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(detto, function () {}); return; }
    var t = nuovo('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'; d.body.appendChild(t); t.select();
    try { d.execCommand('copy'); detto(); } catch (err) {}
    t.remove();
  });

  /* ---------- 5. la stampa da vicino dopo le righe di servizio, le briciole in fondo ---------- */
  function riordina() {
    var info = scheda.querySelector('[id^="ProductInfo-"]'), destra = scheda.querySelector('.bh-sn-destra');
    var lente = d.querySelector('#MainContent .bh-lente');
    var sez = lente && lente.closest('.shopify-section');
    if (info && destra && sez && !info.contains(sez)) destra.after(sez);
    var bric = scheda.querySelector('.product__right-column > .view-desktop');
    var main = d.getElementById('MainContent');
    if (bric && main) {
      var box = nuovo('div', 'bh-sn-briciole');
      box.appendChild(bric);
      main.appendChild(box);
    }
  }
  function avvia() { riordina(); lastraR1(); disegnaSegmenti(); aggiornaCassa(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', avvia); else setTimeout(avvia, 0);
})();
